module.exports = {"130208001":"太平路街道","130208002":"燕山路街道","130208003":"浭阳街道","130208100":"丰润镇","130208102":"任各庄镇","130208103":"左家坞镇","130208104":"泉河头镇","130208105":"王官营镇","130208106":"火石营镇","130208109":"新军屯镇","130208110":"小张各庄镇","130208111":"丰登坞镇","130208112":"李钊庄镇","130208113":"白官屯镇","130208114":"石各庄镇","130208115":"沙流河镇","130208116":"七树庄镇","130208117":"杨官林镇","130208118":"银城铺镇","130208119":"常庄镇","130208202":"姜家营乡","130208205":"欢喜庄乡","130208208":"刘家营乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130208.json
// module id = 86
// module chunks = 0